export const TrackingEvents = {
  PAGE_VIEW: 'PAGE_VIEW',
  QUIZ_STARTED: 'QUIZ_STARTED',
  QUIZ_COMPLETED: 'QUIZ_COMPLETED',
  LEAD_CREATED: 'LEAD_CREATED',
  CHECKOUT_STARTED: 'CHECKOUT_STARTED',
  PAYMENT_INFO_ADDED: 'PAYMENT_INFO_ADDED',
  PAYMENT_ATTEMPTED: 'PAYMENT_ATTEMPTED',
  PURCHASE_COMPLETED: 'PURCHASE_COMPLETED',
  PURCHASE_UPSELL: 'PURCHASE_UPSELL',
  TRUSTPILOT_REVIEW_OPENED: 'TRUSTPILOT_REVIEW_OPENED',
};
